/**
 * Labstep
 *
 * @module components/ResourceItem/Action/Menu
 * @desc Action Menu for resourceItem
 */

import { SignatureActionRevoke } from 'labstep-web/components/Signature/Action/Revoke';
import { ActionMenu } from 'labstep-web/core/Action/Menu';
import type React from 'react';
import type { ISignatureActionMenuProps } from './types';

export const SignatureActionMenu: React.FC<
  ISignatureActionMenuProps
> = ({ signature, experimentWorkflow, type, actions }) => (
  <ActionMenu type={type}>
    {actions.includes('revoke') && (
      <SignatureActionRevoke
        signature={signature}
        experimentWorkflow={experimentWorkflow}
      />
    )}
  </ActionMenu>
);

SignatureActionMenu.defaultProps = {
  type: 'icon',
};
